import { createCustomerComment } from 'core/api/customer.api';
// eslint-disable-next-line no-unused-vars
import { IEditCommentError, IDraftComment } from 'shared/widgets/Comments/Comments.models';
import {
  createCommentFailure,
  createCommentRequest,
  createCommentSuccess,
} from 'pages/Customers/CustomersComments/CreateComment/actionCreators';

const createCommentAction = (
  customerId: string | number,
  formData: IDraftComment,
) => async (dispatch) => {
  try {
    dispatch(createCommentRequest());
    const { data } = await createCustomerComment(customerId, formData);

    dispatch(createCommentSuccess(data));
  } catch (error) {
    const { response: { data: { text, detail } } } = error as IEditCommentError;
    dispatch(createCommentFailure(detail || text));
    throw error;
  }
};

export default createCommentAction;
